import { actions } from './actions'
import { mutations } from './mutations'

export const doctorLocator = {
  namespaced: true,
  state: {
    visible: false,
    componentIsLoaded: false,
  },
  getters: {
    isVisible: (state) => state.visible,
    componentIsLoaded: (state) => state.componentIsLoaded,
    getIsVisibleDoctorLocator: (state) => state.visible,
  },
  mutations,
  actions,
}
